import { MCPEvaluation } from '../types';

// Tipos extendidos para la vista de detalle
export interface DetailedEvaluation extends MCPEvaluation {
    evaluation?: {
        overall_score: number;
        feedback: string;
        criteria_scores: Array<{
            name: string;
            score: number;
            weight: number;
            description: string;
        }>;
    };
    improvement_text?: string;
    // 🆕 Campos de mejora del backend
    improved_query?: string;
    improvement_explanation?: string;
    improvement_model?: string;
    improvement_timestamp?: string;
    improvement_data?: Record<string, any>;
    has_improvement?: boolean;
}

// ❌ ELIMINADAS TODAS LAS FUNCIONES DE GENERACIÓN DE DATOS FALSOS
// Solo se usan datos reales de la base de datos

// Transformer principal - SOLO DATOS REALES
export function transformToDetailedEvaluation(evaluation: MCPEvaluation): DetailedEvaluation {
    // Usar solo el score real del API
    const score = evaluation.overall_score || evaluation.score || 0;

    // SOLO usar datos reales - NO generar nada falso
    const realFeedback = evaluation.feedback || '';

    // Convertir criteria_scores reales si existen
    const realCriteriaScores = evaluation.criteria_scores && Object.keys(evaluation.criteria_scores).length > 0
        ? Object.entries(evaluation.criteria_scores).map(([name, score]) => ({
            name,
            score: typeof score === 'number' ? score : parseFloat(score as string) || 0,
            weight: 25, // Peso por defecto
            description: `Criterio ${name}`
        }))
        : []; // Array vacío si no hay datos reales

    return {
        ...evaluation,
        evaluation: {
            overall_score: score,
            feedback: realFeedback,
            criteria_scores: realCriteriaScores
        },
        improvement_text: realFeedback ? "Análisis detallado disponible en el feedback principal." : "",
        // 🆕 Pasar campos de mejora del backend
        improved_query: evaluation.improved_query,
        improvement_explanation: evaluation.improvement_explanation,
        improvement_model: evaluation.improvement_model,
        improvement_timestamp: evaluation.improvement_timestamp,
        improvement_data: evaluation.improvement_data,
        has_improvement: evaluation.has_improvement,
    };
}

// Función auxiliar para verificar si una evaluación ya tiene datos extendidos
export function hasDetailedData(evaluation: MCPEvaluation): evaluation is DetailedEvaluation {
    return 'evaluation' in evaluation && evaluation.evaluation !== undefined;
} 